import React, { useEffect, useState } from "react";
import PeopleItem from "components/Home/People/PeopleItem/PeopleItem";
import Avatar from "components/Home/ui/Avatar";
import { ADMIN_CODE, MEMBER_CODE } from "constants/constants";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import {
  selectMeAdmin,
  selectMeLocked,
  selectMembersMuted,
  selectMembersShoutable,
  selectMeMuted,
  selectMeShoutable,
  selectMyLuid,
  selectPeople,
} from "slices/spaceMediaSlice";
import { selectCurrentSpaceId } from "slices/spaceSlice";
import { highlightCircle, unhighlightCircle } from "space/spaceDraws";
import AdminControls from "./AdminControls/AdminControls";

const SpacePeople = () => {
  const myDeets = useSelector(selectCurrentUserAttributes);
  const meMuted = useSelector(selectMeMuted);
  const meShoutable = useSelector(selectMeShoutable);
  const meLocked = useSelector(selectMeLocked);
  const currentSpace = useSelector(selectCurrentSpaceId);
  const membersMuted = useSelector(selectMembersMuted);
  const membersShoutable = useSelector(selectMembersShoutable);
  const peopleData = useSelector(selectPeople);
  const [visibleList, setVisibleList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const myLuid = useSelector(selectMyLuid);
  const meAdmin = useSelector(selectMeAdmin);

  useEffect(() => {
    let visibleList = [];
    for (let luid in peopleData) {
      let name =
        peopleData[luid].given_name + " " + peopleData[luid].family_name;
      if (
        name.toLowerCase().includes(searchTerm.toLowerCase()) &&
        myLuid !== luid
      ) {
        visibleList.push(peopleData[luid]);
      }
    }
    setVisibleList(visibleList);
  }, [searchTerm, setVisibleList, myLuid, peopleData]);

  const renderedPeople = () => {
    let items = [];
    visibleList.forEach((person) => {
      items.push(
        <div
          key={person.uuid}
          onMouseEnter={() => highlightCircle(person.luid)}
          onMouseLeave={() => unhighlightCircle(person.luid)}
        >
          <PeopleItem
            type={"SPACE"}
            currentSpace={currentSpace}
            user_id={person.uuid}
            luid={person.luid}
            customStyle={{ width: "217px" }}
            avatar={
              <div
                className={`Txt-avatar d-inline-block Txt-space-people-highlight`}
              >
                <Avatar
                  avatar_key={person.avatar_key}
                  given_name={person.given_name}
                  family_name={person.family_name}
                />
              </div>
            }
            given_name={person.given_name}
            family_name={person.family_name}
            other_role_id={person.admin ? ADMIN_CODE : MEMBER_CODE}
            meAdmin={meAdmin}
            currentUserId={myDeets.id}
            peopleMedia={peopleData}
            membersMuted={membersMuted}
            membersShoutable={membersShoutable}
          />
        </div>
      );
    });
    return items;
  };

  return (
    <>
      <div className="me">
        <PeopleItem
          type={"SPACE"}
          currentSpace={currentSpace}
          user_id={myDeets.id}
          customStyle={{ width: "225px" }}
          avatar={
            <div
              className={`Txt-avatar d-inline-block  Txt-space-people-highlight`}
            >
              <Avatar
                avatar_key={myDeets.avatar_key}
                given_name={myDeets.given_name}
                family_name={myDeets.family_name}
              />
            </div>
          }
          given_name={myDeets.given_name}
          family_name={myDeets.family_name}
          other_role_id={meAdmin ? ADMIN_CODE : MEMBER_CODE}
          currentUserId={myDeets.id}
          peopleMedia={{
            1: {
              uuid: myDeets.id,
              muted: meMuted,
              admin: meAdmin,
              shoutable: meShoutable,
              mutedForMe: false,
              locked: meLocked,
            },
          }}
          membersMuted={membersMuted}
          membersShoutable={membersShoutable}
        />
      </div>
      {meAdmin && <AdminControls />}
      <hr />
      <input
        type="text"
        className="input-box inputSearch"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search by name"
      />
      <div className={`inSpace people-list`}>{renderedPeople()}</div>
    </>
  );
};

export default SpacePeople;
